<template>
  <div class="container" :style="hasToken ? 'padding-bottom:130px;' : ''">
    <div
      v-wechat-title="($route.meta.title = info.ContactName + '的名片')"
    ></div>
    <div class="topBox">
      <div class="mcb_item">
        <img src="../../../static/images/index/nc_bg01.png" class="mcbi_bg" />
        <van-image
          fit="cover"
          :src="info.Photo"
          round
          error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
        ></van-image>
        <div class="mcbi_top">
          <div class="name">{{ info.ContactName }}</div>
          <div>{{ info.Duty }}</div>
          <div style="margin-top: 17px">
            <span class="iconfont icon-phone"></span>{{ info.Mobile }}
          </div>
          <div style="margin-top: 7px">
            <span class="iconfont icon-email-fill"></span>{{ info.Email }}
          </div>
        </div>
        <div class="mcbi_btm">
          <div class="company overFlowTwo">{{ info.CompanyName }}</div>
          <div class="overFlowTwo">{{ info.FullAddress }}</div>
        </div>
      </div>
      <div class="business" v-if="info.MainSupply">
        <div>业务范围</div>
        <div>{{ info.MainSupply }}</div>
      </div>
    </div>

    <div class="classifyNav" :style="info.MainSupply ? '' : 'margin-top:10px;'">
      <van-tabs
        type="line"
        v-model="type"
        title-active-color="#d62f2f"
        line-width="32px"
        line-height="5px"
        @change="typeClick(info.BusinessMemberId)"
        swipeable
        custom-class="vanTabs"
      >
        <van-tab title="TA的动态"></van-tab>
        <div v-if="info.MemberID > 0">
          <van-tab title="TA的公司展厅"></van-tab>
        </div>
      </van-tabs>
    </div>

    <!-- 动态列表 -->
    <div v-if="delay">
      <div class="listBox" style="padding-bottom: 60px">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getListHandle"
        >
          <dynamic-list :list="list"></dynamic-list>
        </van-list>
        <div class="noDataBox" v-if="list.length == 0">
          <span class="iconfont icon-kong"></span>
          <div>什么也没有！</div>
        </div>
      </div>
    </div>

    <!-- 操作栏 按钮、轮播 -->
    <div v-if="hasToken">
      <div class="banner-box" v-if="bannerList.length == 0">
        <div class="bb_left nocard">
          <div class="img"><span class="iconfont icon-account1"></span></div>
          <span>暂无名片</span>
        </div>
        <router-link class="btn red" to="/addPostcard"
          >我要创建名片</router-link
        >
      </div>
      <div class="banner-box" v-else>
        <div class="bb_left">
          <van-swipe
            class="swiper-box"
            @change="swiperBannerChange"
            interval="3000"
            duration="1000"
          >
            <van-swipe-item
              v-for="(item, index) in bannerList"
              :key="index"
              class="bbls_item"
              @click="showCard(item)"
            >
              <div class="bblsi_left">
                <div class="name">{{ item.ContactName }}</div>
                <div>{{ item.Duty }}</div>
                <div>{{ item.CompanyName }}</div>
              </div>
              <van-image
                :src="item.Photo"
                fit="cover"
                round
                error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
              ></van-image>
            </van-swipe-item>
          </van-swipe>
          <!--重置小圆点的样式 -->
          <div class="dots">
            <div
              v-for="(item, index) in bannerList"
              :key="index"
              class="dot"
              :class="index == bannerCurrent ? 'active' : ''"
            ></div>
          </div>
        </div>
        <div class="btn red" @click="shareMycard">分享我的名片</div>
      </div>
    </div>
    <div class="btn-box" style="padding: 40rpx 90rpx" v-else>
      <router-link class="btn" to="/addPostcard">我要创建名片</router-link>
      <div class="btn red" @click.stop="saveHandle">保存该名片</div>
    </div>

    <!-- 海报名片 -->
    <van-overlay :show="show">
      <div class="posterImg">
        <img
          src="../../../static/images/index/close.png"
          class="closeImg"
          @click.stop="closeCodeClick"
        />
        <div ref="imageDom">
          <div class="listItem">
            <img src="../../../static/images/index/nc_bg01.png" />
            <div class="topBox">
              <div class="leftBox">
                <div class="name">{{ cardInfo.ContactName }}</div>
                <div class="job">{{ cardInfo.Duty }}</div>
              </div>
              <van-image fit="cover" :src="base64ImgData" round></van-image>
            </div>
            <div class="bottomBox">
              <div class="sitem">
                <span class="iconfont icon-phone"></span>
                <span>{{ cardInfo.Mobile }}</span>
              </div>
              <div class="sitem">
                <span class="iconfont icon-email-fill"></span>
                <span>{{ cardInfo.Email }}</span>
              </div>
              <div class="company">{{ cardInfo.CompanyName }}</div>
              <div class="address">{{ cardInfo.FullAddress }}</div>
            </div>
          </div>
          <div class="codeBox">
            <div class="codeTitle" v-if="cardInfo.MainSupply">业务范围</div>
            <div class="codeContent" v-if="cardInfo.MainSupply">
              {{ cardInfo.MainSupply }}
            </div>
            <div class="ercodeBox">
              <div class="ercode" ref="qrCodeUrl"></div>
              <div>扫码查看相关详情</div>
            </div>
          </div>
        </div>
        <img :src="imgcode" v-if="imgcode" class="saveImg" />
      </div>
    </van-overlay>

    <!--转发-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>
    <van-overlay v-show="showLayer" @click="showLayer = false"></van-overlay>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import { getShareData } from "@/utils/share";
import { converPhotoBase64 } from "@/api/product";
import DynamicList from "@/components/dynamicList.vue";
import {
  memberBusinessContactInfo,
  memberPostList,
  loginMemberBusinessContactList,
  memberBusinessContactFolders,
} from "@/api/index";
import {
  List,
  Swipe,
  SwipeItem,
  Tabs,
  Tab,
  Image,
  Col,
  Row,
  Icon,
  Overlay,
  Toast,
} from "vant";
export default {
  name: "receivePostcard",
  components: {
    "van-list": List,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-image": Image,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-col": Col,
    "van-row": Row,
    "van-icon": Icon,
    "van-overlay": Overlay,
    Toast,
    DynamicList,
  },
  data() {
    return {
      hasToken: false,
      type: 0,
      info: {},
      showLayer: false,

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],
      delay: false,

      bannerList: [],
      bannerCurrent: 0,

      cardInfo: {}, //名片信息
      show: false,
      showLayer: false,
      codeUrl: process.env.VUE_APP_BASE_HREF + "/receivePostcard?id=", //二维码链接
      imgcode: "", //生成的二维码图片
      base64ImgData: "",
    };
  },
  methods: {
    //分享我的名片
    shareMycard() {
      this.showLayer = true;
      var card = this.bannerList[this.bannerCurrent];
      getShareData(
        process.env.VUE_APP_BASE_HREF + "/receivePostcard?id=" + card.ContactID,
        card.ContactName + "的名片，快来看看呀",
        "",
        card.ShareImg
      );
    },

    //点击名片
    showCard(item) {
      this.show = true;
      this.cardInfo = item;
      this.codeUrl =
        process.env.VUE_APP_BASE_HREF + "/receivePostcard?id=" + item.ContactID;
      this.pictureFormat(item.Photo);
      this.qrcode();
      this.$refs.qrCodeUrl = "";
    },

    //关闭弹窗
    closeCodeClick() {
      this.show = false;
    },

    //获取名片详情
    getDetail() {
      var that = this;
      var data = {
        ContactID: that.$route.query.id,
      };
      memberBusinessContactInfo(data).then((res) => {
        that.info = res.Data;
        that.getListHandle(res.Data.BusinessMemberId);
      });
    },

    //转换图片格式
    async pictureFormat(photo) {
      var that = this;
      var data = {
        Photo: photo,
      };
      await converPhotoBase64(data).then((res) => {
        that.base64ImgData = res.Data;
        that.generatePosterImage();
      });
    },

    //整张海报图片生成
    generatePosterImage() {
      var that = this;
      html2canvas(that.$refs.imageDom, {
        backgroundColor: "transparent", //设置透明背景
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true, //允许跨域图片
        taintTest: false, //是否在渲染前测试图片
      }).then((canvas) => {
        let imgUrl = canvas.toDataURL("image/png"); // 转成图片，生成图片地址
        that.imgcode = imgUrl;
        Toast("长按保存图片");
      });
    },

    // 生成二维码
    qrcode() {
      var that = this;
      let qrcode = new QRCode(this.$refs.qrCodeUrl, {
        width: 98, // 宽度
        height: 98, // 高度
        background: "#ffffff", // 背景色
        foreground: "#000000", // 前景色
        text: that.codeUrl, // 二维码内容
        render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      });
    },

    //tab切换
    typeClick(bid) {
      this.$router.push({ path: "/storeShow", query: { mid: bid } });
    },

    //获取动态列表
    getListHandle(businessMemberId) {
      var that = this;
      var data = {
        MemberId: businessMemberId,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      memberPostList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.delay = true;
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //获取名片列表
    getBannerList() {
      loginMemberBusinessContactList().then((res) => {
        this.bannerList = res.Data.List;
      });
    },

    //保存名片
    async saveHandle() {
      var that = this;
      await memberBusinessContactFolders({
        ContactID: that.$route.query.id,
      }).then((res) => {
        Toast("您已保存改名片！");
      });
    },

    //我的名片轮播切换-自制定点
    swiperBannerChange(e) {
      this.bannerCurrent = e;
    },

    //轮播点击
    bannerClick() {
      var canvasH = 390,
        info = this.bannerList[this.bannerCurrent];
      if (info.MainSupply) {
        let row = Math.ceil(info.MainSupply.length / 25);
        canvasH = 230 + 50 + (row > 6 ? 6 : row) * 18 + 16 + 161;
      }
      this.bannerInfo = info;
    },
  },

  mounted() {
    this.getDetail();
    if (localStorage.token != "" && localStorage.token != null) {
      this.saveHandle();
      this.hasToken = true;
      this.getBannerList();
    }
  },
};
</script>
<style lang="less" scoped>
.container {
  padding: 20px 0 50px 0;
  .topBox {
    margin: 0 12px;
    .mcb_item {
      border-radius: 20px;
      position: relative;
      height: 230px;
      margin-top: 16px;
      padding: 0 25px;
      box-sizing: border-box;
      color: #333333;
      font-size: 13px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &:first-child {
        margin-top: 0px;
      }
      .mcbi_bg {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
      }
      .van-image {
        display: block;
        width: 70px;
        height: 70px;
        position: absolute;
        top: 32px;
        right: 25px;
      }

      .mcbi_top {
        width: 225px;
        div {
          display: flex;
          align-items: center;
          line-height: 18px;
        }
        .name {
          font-weight: bold;
          color: #000000;
          font-size: 20px;
          line-height: 21px;
          margin-bottom: 6px;
          padding-top: 7px;
        }
        .iconfont {
          color: #5e8ae3;
          font-size: 12px;
          line-height: 12px;
          margin-right: 10px;
        }
      }
      .mcbi_btm {
        margin-top: 15px;
        div {
          margin-top: 5px;
        }
        .company {
          font-size: 15px;
          font-weight: bold;
          line-height: 18px;
        }
      }
    }
    .business {
      background-color: #5e8ae3;
      font-size: 12px;
      line-height: 18px;
      color: #fff;
      position: relative;
      z-index: -2;
      top: -25px;
      border-radius: 0px 0px 20px 20px;
      padding: 47px 24px 24px 24px;
      div {
        &:first-child {
          font-weight: bold;
          margin-bottom: 25rpx;
        }
      }
      &::before {
        content: "";
        display: block;
        position: absolute;
        z-index: -50;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        box-shadow: 0px 0px 17px #5e8ae3;
        width: 277px;
        height: 50px;
      }
    }
  }
  .classifyNav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    /deep/.van-tab {
      flex: inherit !important;
      -webkit-flex: inherit !important;
      width: 120px !important;
      font-size: 14px !important;
    }
    /deep/.van-tab--active {
      font-weight: bold;
    }
    /deep/.van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border-width: 0px;
    }
  }
  .btn-box,
  .banner-box {
    border-top: 1px solid #ccc;
    background-color: #ebeff6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .btn {
    width: 115px;
    height: 35px;
    background: #fff;
    color: #d62f2f;
    border: 1px solid #d62f2f;
    border-radius: 18px;
    font-size: 13px;
    text-align: center;
    line-height: 35px;
    margin: 20px;
  }

  .btn.red {
    background: #d62f2f;
    color: #fff;
  }

  .banner-box {
    height: 130px;
    padding: 0 12px;
    &::before {
      content: "我的名片";
      display: block;
      position: absolute;
      top: 12px;
      left: 12px;
      font-size: 10px;
      color: #999;
    }
    .bb_left {
      position: relative;
      width: 200px;
      height: 60px;
      background: #fff;
      box-shadow: 0px 0px 16rpx 0px rgba(153, 182, 230, 0.26);
      border-radius: 6px;
      .swiper-box {
        width: 100%;
        height: 100%;
        .bbls_item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 11px;
          box-sizing: border-box;
          .bblsi_left {
            width: 130px;
            div {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 10px;
              line-height: 12px;
              color: #666666;
            }
            .name {
              font-weight: bold;
              color: #333333;
              line-height: 13px;
              line-height: 18px;
              margin-bottom: 3px;
            }
          }
          .van-image {
            display: block;
            /deep/ .van-image__img {
              width: 40px;
              height: 40px;
              border-radius: 50%;
            }
          }
        }
        /deep/.van-swipe__indicators {
          display: none;
        }
      }
      .dots {
        display: flex;
        flex-direction: row;
        position: absolute;
        right: 0;
        bottom: -18px;
        transform: translate(-50%, 0);
      }
      .dot {
        width: 6px;
        height: 6px;
        background: #fff;
        border: 1px solid #5e8ae3;
        border-radius: 50%;
        margin-left: 4px;
        &:first-child {
          margin-left: 0px;
        }
      }
      .active {
        background: #5e8ae3;
      }
    }
    .nocard {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: #999999;
      .img {
        text-align: center;
        line-height: 40px;
        width: 40px;
        height: 40px;
        background: #eee;
        border-radius: 50%;
        margin-right: 12px;
        .iconfont {
          font-size: 20px;
          line-height: 20px;
          color: #999999;
        }
      }
    }
  }

  .posterImg {
    padding: 8px 12px;
    .codeBox {
      position: relative;
      z-index: -2;
      margin-top: -34px;
      background-color: #5e8ae3;
      border-radius: 0px 0px 20px 20px;
      color: #fff;
      font-size: 12px;
      padding: 40px 23px 25px;
      .codeTitle {
        font-size: 12px;
        font-weight: bold;
      }
      .codeContent {
        width: 304px;
        text-align: justify;
        margin-top: 8px;
        padding-bottom: 18px;
        border-bottom: 1px solid #ddd;
      }
      .ercodeBox {
        padding-top: 13px;
        text-align: center;
        .ercode {
          display: inline-block;
          /deep/img {
            width: 98px;
            height: 98px;
            background-color: #fff; //设置白色背景色
            padding: 6px; // 利用padding的特性，挤出白边
            box-sizing: border-box;
          }
        }
      }
    }
    .closeImg {
      width: 27px;
      height: 27px;
      margin-left: 90%;
    }
    .saveImg {
      position: absolute;
      z-index: 12;
      top: 54px;
      left: 12px;
      width: 350px;
      height: auto;
      border-radius: 5px;
    }
    .listItem {
      position: relative;
      width: 350px;
      height: 230px;
      margin-bottom: 16px;
      img {
        width: 350px;
        height: 230px;
        position: absolute;
        z-index: -1;
      }
      .topBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0px 25px;
        .leftBox {
          margin-top: 32px;
          .name {
            font-size: 25px;
            color: #333;
            font-weight: bold;
          }
          .job {
            font-size: 13px;
            font-weight: 400;
            color: #333;
            margin-top: 6px;
            margin-bottom: 12px;
          }
        }
        .van-image {
          display: block;
          width: 70px;
          height: 70px;
          margin-top: 28px;
        }
      }
      .bottomBox {
        margin: 0px 25px;
        .sitem {
          color: #333;
          font-size: 13px;
          margin-bottom: 8px;
          .iconfont {
            font-size: 12px;
            color: #5e8ae3;
            margin-right: 12px;
          }
        }
        .company {
          font-size: 15px;
          color: #333;
          font-weight: bold;
          margin-top: 10px;
          margin-bottom: 4px;
        }
        .address {
          font-size: 13px;
          color: #333;
          font-weight: 400;
        }
      }
    }
  }
}
</style>